import React from 'react';
import { Row, Col } from 'antd';
import { useParams } from 'react-router';
import { Typography } from 'ui-kit';
import Svg from 'react-inlinesvg';
import emptyListIcon from './images/empty-cart.svg';

const AdditionFirstProduct: React.FC = () => {
  const { category = 'all' } = useParams<{ category?: string }>();
  return (
    <Row gutter={[0, 20]}>
      {category !== 'local-products' && (
        <>
          <Col md={24} lg={14} className="DashboardStoreProducts-emptyList">
            <Svg src={emptyListIcon} />
            <Typography variant="body2">
              You haven&lsquo;t added any products to your store yet.
            </Typography>
          </Col>
        </>
      )}
    </Row>
  );
};

export default AdditionFirstProduct;
